import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideSnackbar, showSnackbar } from 'modules/App/store/actions';

const useFreshchatWidget = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user);

  const openFreshChat = useCallback(() => {
    try {
      window.fcWidget.open();

      window.fcWidget.user.setProperties({
        firstName: user.displayName,
        email: user.email,
        uid: user.uid,
      });
    } catch (e) {
      dispatch(showSnackbar('Something went wrong, please reload.'));

      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
    }
  }, [dispatch, user]);

  return {
    openFreshChat,
  };
};

export default useFreshchatWidget;
